import { ThunkType } from "../../../../../core/store/reducers";
import createAttributeApi from "../../api/attributes/createAttribute";
import updateAttributeApi from "../../api/attributes/updateAttribute";
import { setFetchStateAttribute } from "../../productsDataReducer";
import { ProductAttribute } from "../../types";

export const upsertAttribute = (attribute: ProductAttribute): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return;
	}

	dispatch(setFetchStateAttribute({ type: "started" }));

	const { userId } = store.data.auth.current.user;
	const result = attribute.prodAttrId
		? await dispatch(updateAttributeApi(userId, attribute))
		: await dispatch(createAttributeApi(userId, attribute));

	if (result && result.resCode === "OK") {
		dispatch(setFetchStateAttribute({ type: "successful", result: result.resDesc }));
		return result.resDesc;
	} else {
		dispatch(setFetchStateAttribute({ type: "error", errorCode: result?.resCode }));
	}
};
